<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Order</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Order:
    </ion-list-header>

    <ion-list>
        <ion-item>
            <ion-label>
                <span class="line1">Order Number: {{getOrderId()}}</span><br />
                <span class="line2">Purchased On: {{getCreatedDate()}}</span><br />
                <span class="line2">Grand Total: {{this.order?.header?.total | myCurrency}}</span><br />
                <span class="line2">Notes: {{getNote()}}</span><br /><br />
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-list-header color="secondary">
        Order Items:
    </ion-list-header>

    <ion-list class="ion-padding">
        <ion-grid class="ion-margin">
            <ion-row>
                <ion-col size="1"><div class="ion-text-start">SKU</div></ion-col>               
                <ion-col size="6"><div class="ion-text-start">Product</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">Quantity</div></ion-col>               

                <ion-col size="1"><div class="ion-text-end">Unit Price</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">Subtotal</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">Tax</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">Total</div></ion-col>
            </ion-row>
       
            @for (item of order.items; track $index) {
  <ion-row>
                <!-- <pre>item: {{item | json }}</pre>
                <pre>item.tax: {{item.tax | json }}</pre> -->

                <ion-col size="1"><div class="ion-text-start">{{item.sku}}</div></ion-col>
                <ion-col size="6"><div class="ion-text-start">{{item.name}}</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">{{item.quantity}}</div></ion-col>

                <!-- <ion-col size="1"><div class="ion-text-end">{{getUnitPriceFormatted(item)}}</div></ion-col> -->
                <!-- <ion-col size="1"><div class="ion-text-end">{{getSubtotalFormatted(item)}}</div></ion-col> -->
                <!-- <ion-col size="1"><div class="ion-text-end">{{getTaxFormatted(item)}}</div></ion-col> -->
                <!-- <ion-col size="1"><div class="ion-text-end">{{getItemTotalFormatted(item)}}</div></ion-col> -->

                <ion-col size="1"><div class="ion-text-end">{{item.unitPrice | myCurrency}}</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">{{item.subtotal | myCurrency}}</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">{{item.tax | myCurrency}}</div></ion-col>
                <ion-col size="1"><div class="ion-text-end">{{item.total | myCurrency}}</div></ion-col>

                <!-- <ion-col size="1"><div class="ion-text-end">{{item.totalFormatted}}</div></ion-col> -->
            </ion-row>
}
        </ion-grid>
    </ion-list>
</ion-content>